module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showForm === 'set-password') ? _c('form', {
    attrs: {
      "id": "login-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.setPassword()
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Set your account's password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errorPassword
    }
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorPassword))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errorPassword2
    }
  }, [_c('label', {
    attrs: {
      "for": "password2"
    }
  }, [_vm._v("Password again")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password2",
      "type": "password",
      "placeholder": "Enter your password again"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorPassword2))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Login to the system")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showForm === 'send-new-token-with-email') ? _c('form', {
    attrs: {
      "id": "login-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resendToken()
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Oops.. the link is invalid")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      error: _vm.errorEmail
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Enter your email below in order to get a confirmation link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Enter your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorEmail))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Login to the system")])], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "value": "Submit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit",
      "value": "Send confirmation link"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6433c30e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ConfirmEmail.vue
// module id = 661
// module chunks = 0